module.exports = __webpack_public_path__ + "components/panel/check-yeti/static/check-yeti--it-51c0b8b29264130bfcd5c53ed3daf96c.webp";